import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Tabber from 'components/Tabber';
import ServiceGroupEditMain from 'components/ServiceGroupEditMain';
import ServiceGroupEditServices from 'components/ServiceGroupEditServices';

import { ServiceGroupEditTabs_serviceGroup$key } from '__generated__/ServiceGroupEditTabs_serviceGroup.graphql';

type Props = {
  serviceGroup: ServiceGroupEditTabs_serviceGroup$key;
};

const ServiceGroupEditTabs: FC<Props> = props => {
  const serviceGroup = useFragment(
    graphql`
      fragment ServiceGroupEditTabs_serviceGroup on ServiceGroup {
        ...ServiceGroupEditMain_serviceGroup
        ...ServiceGroupEditServices_serviceGroup
      }
    `,
    props.serviceGroup
  );

  return (
    <Tabber
      tabs={[
        {
          title: 'Bendra informacija',
          component: <ServiceGroupEditMain serviceGroup={serviceGroup} />,
          hash: 'main',
        },
        {
          title: 'Paslaugos',
          component: <ServiceGroupEditServices serviceGroup={serviceGroup} />,
          hash: 'services',
        },
      ]}
    />
  );
};

export default ServiceGroupEditTabs;
